import { useEffect } from "react";

import useShouldKeepChatHidden from "@app/util/contexts/useShouldKeepChatHidden";

const ELEMENT_ID = "hubspot-messages-iframe-container";

const useHiddenChat = () => {
  const shouldKeepChatHidden = useShouldKeepChatHidden();
  useEffect(() => {
    // nothing to do here, it should be hidden already. Let's not change its state.
    if (shouldKeepChatHidden) {
      return;
    }
    const chat = document.getElementById(ELEMENT_ID);
    if (chat) {
      chat.style.setProperty("display", "none", "important");
    }

    return () => {
      const chat = document.getElementById(ELEMENT_ID);
      if (chat) {
        chat.style.removeProperty("display");
      }
    };
  }, [shouldKeepChatHidden]);
};

export default useHiddenChat;
